import { standard } from '../../constants';

export default {
  ...standard('LOGON'),
  ...standard('LOGOFF'),
};



// WEBPACK FOOTER //
// ./src/modules/auth/constants.js